export const SET_DATA = 'setData';
export const SET_API_STATUS = 'setApiStatus';
export const ADD_TO_SELECTION_LIST = 'addToSelectionList';
export const REMOVE_FROM_SELECTION_LIST = 'removeFromSelectionList';
export const SELECT_ALL = 'selectAll';
export const DESELECT_ALL = 'deselectAll';